import styled from 'react-emotion'

export const MainContainer = styled('div')`
  width: 1124px;
  margin-right: auto;
  margin-left: auto;
  overflow: hidden;
  @media (min-width: 320px) and (max-width: 425px) {
    width: 90%;
  }
  @media (min-width: 426px) and (max-width: 767px) {
    width: 90%;
  }
  @media (min-width: 768px) and (max-width: 1123px) {
    width: 90%;
  }
`
